/**
 * Auth 相关 API
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import axios from 'axios'
import type { AxiosRequestConfig } from 'axios'
import type { ApiResponse } from '../types'
import type * as Types from '../types'
import type { ApiDefinition } from './_types'

/**
 * Auth 资源的 API 接口
 */
export class AuthAPI {
  /**
   * 管理员登录
   */
  static async login(
    data: Types.AuthLoginReq,
    config?: AxiosRequestConfig
  ): Promise<ApiResponse<Types.AuthLoginRes>> {
    return axios.post(`/api/v1/auth/login`, data, config)
  }

  /**
   * 管理员登出
   */
  static async logout(
    data: Types.AuthLogoutReq,
    config?: AxiosRequestConfig
  ): Promise<ApiResponse<Types.AuthLogoutRes>> {
    return axios.post(`/api/v1/auth/logout`, data, config)
  }

  /**
   * 刷新访问令牌
   */
  static async refresh(
    data: Types.AuthRefreshReq,
    config?: AxiosRequestConfig
  ): Promise<ApiResponse<Types.AuthRefreshRes>> {
    return axios.post(`/api/v1/auth/refresh`, data, config)
  }

  /**
   * 发送验证码
   */
  static async sendCaptcha(
    data: Types.AuthSendCaptchaReq,
    config?: AxiosRequestConfig
  ): Promise<ApiResponse<Types.AuthSendCaptchaRes>> {
    return axios.post(`/api/v1/auth/send-captcha`, data, config)
  }
}

/**
 * Auth 资源的 API 定义
 */
export const AuthApiDefs: Record<string, ApiDefinition> = {
  Auth_login: {
    endpoint: '/api/v1/auth/login',
    method: 'POST',
    resource: 'Auth',
    operation: 'login',
    summary: '管理员登录',
    label: '管理员登录',
    requestType: 'AuthLoginReq',
    responseType: 'AuthLoginRes',
    contentType: 'application/json',
  },
  Auth_logout: {
    endpoint: '/api/v1/auth/logout',
    method: 'POST',
    resource: 'Auth',
    operation: 'logout',
    summary: '管理员登出',
    label: '管理员登出',
    requestType: 'AuthLogoutReq',
    responseType: 'AuthLogoutRes',
    contentType: 'application/json',
  },
  Auth_refresh: {
    endpoint: '/api/v1/auth/refresh',
    method: 'POST',
    resource: 'Auth',
    operation: 'refresh',
    summary: '刷新访问令牌',
    label: '刷新访问令牌',
    requestType: 'AuthRefreshReq',
    responseType: 'AuthRefreshRes',
    contentType: 'application/json',
  },
  Auth_sendCaptcha: {
    endpoint: '/api/v1/auth/send-captcha',
    method: 'POST',
    resource: 'Auth',
    operation: 'sendCaptcha',
    summary: '发送验证码',
    label: '发送验证码',
    requestType: 'AuthSendCaptchaReq',
    responseType: 'AuthSendCaptchaRes',
    contentType: 'application/json',
  },
}
